import { render, staticRenderFns } from "./TokensComponent.vue?vue&type=template&id=127445aa&scoped=true"
import script from "./TokensComponent.vue?vue&type=script&lang=js"
export * from "./TokensComponent.vue?vue&type=script&lang=js"
import style0 from "./TokensComponent.vue?vue&type=style&index=0&id=127445aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127445aa",
  null
  
)

export default component.exports